/**
 * Preset drafts: the data shown in the preset form. Plain functions with no state, so any
 * window can use them (the inspector's "Save as preset", the presets window's "New preset").
 */
import type { Graph } from "@protocol/Graph";
import type { Node } from "@protocol/Node";
import type { Preset } from "@protocol/Preset";

/** A preset being created or edited (an empty `id` means "new"). */
export type PresetDraft = Preset;

/** An empty draft. */
export function emptyDraft(): PresetDraft {
  return { id: "", label: "", name: "", kind: "class", categories: [], note: "", data: {}, links: [], folder: "" };
}

/** A draft copying a node and its outgoing links ("Save as preset"). */
export function draftFromNode(node: Node, graph: Graph): PresetDraft {
  const names = new Map(graph.nodes.map((n) => [n.id, n.name]));
  return {
    ...emptyDraft(),
    label: node.name,
    name: node.name,
    kind: node.kind,
    categories: [...node.categories],
    note: node.note,
    data: { ...node.data },
    links: graph.links.filter((l) => l.from === node.id).map((l) => ({ kind: l.kind, target: names.get(l.to) ?? l.to })),
  };
}
